import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'
import { DiffuseEndOfStayAppreciationsInput, DiffuseEndOfStayAppreciationsResponse } from './types'

/** Same sharing for OTO individuel youths (no centre), per youth: ids are enrollment ids. */
export const diffuseOtoIndividualEndOfStayAppreciations = (
  input: DiffuseEndOfStayAppreciationsInput
) => {
  return restApiClient
    .url(constructApiUrl(API.enrollments.diffuseOtoIndividualEndOfStayAppreciations.url, null))
    .post<DiffuseEndOfStayAppreciationsResponse>(input)
}
